import { render, staticRenderFns } from "./previous-page-btn.vue?vue&type=template&id=3d6c270c&scoped=true&"
import script from "./previous-page-btn.vue?vue&type=script&lang=js&"
export * from "./previous-page-btn.vue?vue&type=script&lang=js&"
import style0 from "./previous-page-btn.vue?vue&type=style&index=0&id=3d6c270c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c270c",
  null
  
)

export default component.exports